import React from 'react';

class KovErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="kov-error-boundary">
        <p>This component is not in react!</p>
      </div>
    );
  }
}

export default KovErrorBoundary;
